import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20composition%20of%20fashion%20and%20lifestyle%20products%20including%20leather%20goods%20accessories%20and%20textiles%20arranged%20artistically%20on%20a%20soft%20cream%20surface%2C%20warm%20natural%20lighting%2C%20European%20minimalist%20aesthetic%2C%20soft%20earth%20tones%20balanced%20with%20subtle%20pastels%2C%20high%20end%20editorial%20product%20photography%2C%20clean%20harmonious%20composition%20with%20generous%20negative%20space&width=1920&height=1080&seq=hero-bg-main-v2&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
              ItaoBuy Spreadsheet:
              <br />
              <span className="text-white/90">la guida completa per organizzare</span>
              <br />
              <span className="text-white/90">prodotti, prezzi e ordini</span>
            </h1>
            <p className="text-white/80 text-base md:text-lg mb-8 max-w-xl mx-auto lg:mx-0">
              Gestisci facilmente prodotti, confronta prezzi, monitora ordini e ottimizza i tuoi acquisti con strumenti spreadsheet professionali.
            </p>

            <div className="flex flex-wrap items-center gap-3 justify-center lg:justify-start mb-6">
              <span className="flex items-center gap-1.5 text-white/70 text-xs">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-green-400"></i>
                </span>
                Guide aggiornate
              </span>
              <span className="flex items-center gap-1.5 text-white/70 text-xs">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-green-400"></i>
                </span>
                Tabelle professionali
              </span>
              <span className="flex items-center gap-1.5 text-white/70 text-xs">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-green-400"></i>
                </span>
                Sicurezza dei dati
              </span>
              <span className="flex items-center gap-1.5 text-white/70 text-xs">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-green-400"></i>
                </span>
                Risorse gratuite
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/articoli/guida-completa-itaobuy-spreadsheet"
                className="flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap transition-all duration-200 hover:bg-primary-600"
              >
                Accedi alla guida ItaoBuy Spreadsheet
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm border border-white/30 text-white rounded-full text-sm font-medium cursor-pointer whitespace-nowrap transition-all duration-200 hover:bg-white/25"
              >
                Visita il sito principale
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </a>
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 border border-white/20">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20clean%20spreadsheet%20dashboard%20interface%20displayed%20on%20a%20laptop%20screen%20showing%20organized%20product%20catalog%20with%20thumbnail%20images%20prices%20and%20categories%2C%20warm%20cream%20desk%20setting%2C%20soft%20natural%20light%2C%20professional%20UI%20design%20mockup%2C%20minimalist%20workspace%20aesthetic&width=600&height=400&seq=hero-preview-card-v2&orientation=landscape"
                alt="ItaoBuy Spreadsheet Dashboard Preview"
                title="ItaoBuy Spreadsheet Dashboard Preview"
                className="w-full rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
